// extracted by mini-css-extract-plugin
module.exports = {"shopCampaignLabelList":"ShopCampaignLabel_shopCampaignLabelList__j63Dl","shopCampaignLabelItem":"ShopCampaignLabel_shopCampaignLabelItem__s3dMj"};